import useOpenApiCall from "hooks/useOpenApiCall";

const { apiCall } = useOpenApiCall();

export const fetchHeaderData = () =>
  apiCall({ url: "https://assets.airtel.in/static-assets/cms/b2b/b2b-widgets/json-tnd/b2b-header-data.json" })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
